import { CircularProgress } from '@mui/material';
import DialogStyle from './ConfirmDialog.module.scss';
import Buttons from 'styles/buttons.module.scss';

interface IConfirmDialog {
	type: 'shift' | 'event';
	isLoading: boolean;
	handleDeleteClick: () => void;
	setConfirmDeleteIsOpen: (args: boolean) => void;
}

export default function ConfirmDialog({
	type,
	isLoading,
	handleDeleteClick,
	setConfirmDeleteIsOpen,
}: IConfirmDialog): JSX.Element {
	return (
		<div className={DialogStyle.dialogWrapper}>
			<div className={DialogStyle.dialogContent}>
				<div className={DialogStyle.dialogHeader}>
					<h3 className={DialogStyle.dialogTitle}>Delete {type === 'shift' ? 'Shift' : 'Event'}</h3>
				</div>
				<div className={DialogStyle.dialogBody}>
					<p>Are you sure you want to delete this {type === 'shift' ? 'shift' : 'event'}? This action cannot be undone.</p>
				</div>
				<div className={DialogStyle.dialogFooter}>
					{isLoading ? (
						<div className={DialogStyle.loadingContainer}>
							<CircularProgress size={20} />
							<span>Deleting...</span>
						</div>
					) : (
						<>
							<button 
								type="button"
								className={DialogStyle.cancelButton} 
								onClick={() => setConfirmDeleteIsOpen(false)}
								disabled={isLoading}
							>
								Cancel
							</button>
							<button 
								type="button"
								className={DialogStyle.deleteButton} 
								onClick={handleDeleteClick}
								disabled={isLoading}
							>
								Delete
							</button>
						</>
					)}
				</div>
			</div>
		</div>
	);
}
